<template>
  <div class="tw-p-2 tw-bg-white tw-w-full tw-border tw-border-solid tw-flex tw-items-center tw-gap-2 tw-border-s-0">
      <router-link :to="{ name: 'pages.dashboard.admin' }" class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2"><icon icon="solar:home-smile-bold-duotone" /> <span class="tw-text-sm">{{ $t("dashboard.sidebar.dashboard") }}</span></router-link>
      <span class="tw-text-gray-300">/</span>
      <button disabled class="tw-text-primary-500 tw-text-xl tw-flex tw-items-center tw-gap-2"><span class="tw-text-sm">{{ $t("dashboard.sidebar.products") }}</span></button>
  </div>
  <div class="tw-p-2">
      <div class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-125px)]">
          <div class="tw-justify-between tw-flex tw-items-center tw-h-[40px] tw-gap-2">
            <div class="tw-flex tw-gap-0">
              <FormField
                  v-model="search"
                  @keyup.enter="onSearch"
                  :placeholder="$t('common.products-search-placeholder')"
                  type="text"
                  :hide-errors="true"
                  :hide-label="true"
                  class="tw-min-w-[100px] tw-rounded-e-none tw-peer"
                  input-class="tw-rounded-e-none  tw-border-e-0"
                />
                <select @change="onPerPageChange" v-model="options.per_page" class="tw-w-[40px] tw-text-sm tw-outline-none peer-focus-within:tw-border-y-primary-500 tw-border-e-0 tw-text-center tw-h-[40px] tw-border tw-border-solid tw-border-gray-200 tw-duration-200">
                  <option v-for="item in [5, 10, 20, 50, 75, 100]" :key="item" :value="item" class="tw-px-2">{{ item }}</option>
                </select>
                <a-button @click="onSearch" intent="icon" class="tw-h-[40px] tw-rounded-s-none peer-focus-within:tw-border-y-primary-500 peer-focus-within:tw-border-e-primary-500 !tw-border-b active:!tw-translate-y-none active:!tw-border-bx" icon="clarity:search-line"></a-button>
            </div>
              <a-button class="tw-hidden md:tw-flex" as="router-link" :to="{ name: 'pages.admin.products.create' }" left-icon="heroicons:plus-16-solid">{{ $t("buttons.new-product") }}</a-button>
              <a-button class="md:tw-hidden" as="router-link" :to="{ name: 'pages.admin.products.create' }" icon="heroicons:plus-16-solid"></a-button>
          </div>
          <div class="tw-mt-5 tw-roundedx tw-overflow-hiddenx">
            <ProductTable :loading="loading" :items="products" :options="options" @next="onNext" @previous="onPrevious" />
          </div>
      </div>

  </div>
</template>

<script setup>
import { ref, provide } from 'vue'
import { paginate } from '@/api/products';
import FormField from "@/components/form/FormField";
import ProductTable from '@/views/admin/products/partials/table/ProductTable'

const search = ref('')
const options = ref({ per_page: 10 });
const loading = ref(true)
const products = ref([]);

async function fetchProducts(page = 1) {
  loading.value = true;
  // await paginate({ per_page, page, search: search.value })
  // .then(
  //   ({ data }) => {
  //     products.value = data.data.data;
  //     console.log(products.value)
  //   },
  //   error => {
  //     console.log(error)
  //   }
  // )
  await paginate({ per_page: options.value.per_page, page, search: search.value })
    .then(
      ({ data }) => {
        const { data: items, ...ops } = data.data;
        options.value = ops
        products.value = items;
      },
      error => {
        console.log(error)
      }
    )
  loading.value = false

}

fetchProducts()

const onNext = () => {
  fetchProducts(options.value.current_page + 1)
}

const onPrevious = () => {
  fetchProducts(options.value.current_page - 1)
}

const onPerPageChange = () => {
  fetchProducts()
}


const onSearch = () => {
  fetchProducts()
}

const onCreated = product => {
  products.value.unshift(product);
}

const onUpdate = (product) => {
    products.value = products.value.map((item) => item.id == product.id ? product : item);
} 

provide("onUpdated", onUpdate);
provide("onCreated", onCreated);
</script>

<style>

</style>